module.exports = {"id":"209711","name":"Rasmus Thelander","rating":"72","photo":"./data/images/photos/2/209711.png","club":{"name":"FC Zurich","logo":"./data/images/clubs/FCZurich.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RasmusThelander0.json
// module id = 3545
// module chunks = 0